export default "__VITE_ASSET__D7dj3VHL__"